import { AuthRoutes, userActionTypes, userTypes } from '../app/enums';
import { LoginResponse } from '../models/authentication.interface';
import { defaultUserType, UserContextType, UserType } from '../models/user.interface';
import { Location } from '../models/location.interface' ;
import { isEmpty } from 'lodash';
import { themes } from '../app/enums';

export type UserAction =
  | { type: userActionTypes.LOGIN_USER, user: LoginResponse }
  | { type: userActionTypes.LOAD_USER, user: any, accessToken: string }
  | { type: userActionTypes.LOGOUT_USER }
  | { type: userActionTypes.UPDATE_USER_LIST; userId: string; locations: Location[]}
  | { type: 'field'; fieldName: string; payload: any };

export const login = (state: UserContextType, user: LoginResponse) => {
  let self: UserType = state.self; 
  self.authenticated = true;
  self.password = '';
  self.id = user.user.id;
  self.userName = user.user.userName;
  self.email = user.user.email;
  self.firstName = user.user.firstName;
  self.lastName = user.user.lastName;
  self.userType = user.user.userType;
  self.locations = user.locations;

  let userTheme = themes.DEFAULT

  if(!(isEmpty(self.locations))){
    if(self.locations[0].company.name === 'Manheim') {
      userTheme = themes.MANHEIM
    } else if(self.locations[0].company.name === 'Carvana') {
      userTheme = themes.CARVANA
    }
  }

  let currentPage = '';
  switch(user.user.userType) {
    case userTypes.EXTERNAL: {
      currentPage = AuthRoutes.search;
      break; 
      }
    case userTypes.INTERNAL: {
      currentPage = AuthRoutes.adminSearch;
      break;
      }
    default: {
      currentPage = "/";
      break;
    }
  }

  return {
    ...state,
    self: self,
    modifyUser: defaultUserType,
    userTheme: userTheme,
    accessToken: user.accessToken,
    currentPage,
  };
}

export const loadUser = (state: UserContextType, user: any, accessToken: string) => {
  let self: UserType = state.self; 
  self.authenticated = true;
  self.password = '';
  self.id = user.id;
  self.userName = user.userName;
  self.email = user.email;
  self.firstName = user.firstName;
  self.lastName = user.lastName;
  self.userType = user.userType;

  const locations = localStorage.getItem('locations')
  if(locations)
    self.locations = JSON.parse(locations)
  else
    self.locations = [];

  let userTheme = themes.DEFAULT

  if(!(isEmpty(self.locations))){
    if(self.locations[0].company.name === 'Manheim') {
      userTheme = themes.MANHEIM
    } else if(self.locations[0].company.name === 'Carvana') {
      userTheme = themes.CARVANA
    }
  }
  
  return {
    ...state,
    self: self,
    modifyUser: defaultUserType,
    userTheme: userTheme,
    accessToken,
  };
}

export const logout = (state: UserContextType) => {
  localStorage.removeItem('refreshToken');
  localStorage.removeItem('user');
  localStorage.removeItem('locations');

  return {
    currentPage: '',
    usersList: [],
    userTheme: themes.DEFAULT,
    accessToken: '',
    self: {
      id: '',
      firstName: '',
      lastName: '',
      email: '',
      userName: '',
      password: '',
      authenticated: false,
      locations: [],
      enabled: false,
      settings: '',
      userType: '-1'
    }
  };
}

const updateField = (state: UserContextType, fieldName: string, payload: any) => {
  if(fieldName === 'currentPage' || fieldName === 'usersList'){
    return {
      ...state,
      [fieldName]: payload
    }
  }
  
  const user = state.self;

  state.self = {
    ...user,
    [fieldName]: payload
  }

  return {
    ...state
  }
}

const updateUserList = (state: UserContextType, userId: string, location: Location[]) => {
  const updatedIndex = state.usersList.findIndex(
    user => user.id === userId
  )

  if(updatedIndex > -1){
    state.usersList[updatedIndex].locations = location
  }

  return{
    ...state
  }
}

export const userReducer = (state: UserContextType, action:UserAction) => {
  switch (action.type){
    case 'field': 
      return updateField(state, action.fieldName, action.payload)
    case userActionTypes.LOGIN_USER:
      return login(state, action.user);
    case userActionTypes.LOGOUT_USER:
      return logout(state);
    case userActionTypes.UPDATE_USER_LIST:
      return updateUserList(state, action.userId, action.locations);
    case userActionTypes.LOAD_USER:
      return loadUser(state, action.user, action.accessToken);
    default:
      return state;
  }
}
  